import AppEvents from 'Shared/app-events';

import BookmarkApi from 'Api/bookmark-api';
import CompareApi from 'Api/compare-api';
import CartApi from 'Api/cart-api';

import Util from 'Common/util';
import { VariantItemModel } from 'Models/variantItemModel';

class CompareItem {
    constructor(module, data) {
        this.module = module;

        ko.mapping.fromJS(data, this.#mapping, this);
    }

    #mapping = {
        VariantItem: {
            create: (options) => new VariantItemModel(options.data)
        }
    };

    addToBookmark = async (model, e) => {
        const element = e.currentTarget;

        Util.startLoading(element);

        try {
            await BookmarkApi.addItem(model.ProductId());

            AppEvents.emit("aside.bookmark.show");
        }
        finally {
            Util.stopLoading(element);
        }
    }

    addToCart = async (model, e) => {
        const element = e.currentTarget;

        Util.startLoading(element);

        try {
            await CartApi.addProduct({
                productId: model.ProductId()
            });

            AppEvents.emit("aside.cart.show");
        }
        finally {
            Util.stopLoading(element);
        }
    }
}

export default class CompareModule {

    constructor(data, view) {
        this.view = view;

        ko.mapping.fromJS(data, this.#mapping, this);

        this.loaded(true);
    }

    loading = ko.pureComputed(() => this.view.contextLoading());
    loaded = ko.observable(false);

    #mapping = {
        Items: {
            key: (data) => ko.utils.unwrapObservable(data.Id),
            create: (options) => new CompareItem(this, options.data)
        }
    };

    hasItems = ko.pureComputed(() => this.ItemCount());

    removeItem = (model, e) => {
        const element = e.currentTarget;

        Util.startLoading(element);

        CompareApi.removeItem(model.Id());
    }

    template = ko.pureComputed(() => "compare-container-tpl");

    fadeIn = element => {
        if (element.nodeType === 1) {
            $(element).hide().fadeIn();
        }
    };

    fadeOut = element => {
        if (element.nodeType === 1) {
            $(element).fadeOut(() => $(element).remove());
        }
    };

    dispose() { }
}